import React from 'react'
import { GridCell, GridHeaderCell } from '@progress/kendo-react-grid'
import { withStyles } from '@material-ui/styles'
import Badge from '@material-ui/core/Badge'
import { localized } from 'decorators'
import { isNotNull, isNull } from 'utils/isNotNull'
import { withDialogs } from 'decorators'
import 'polyfills/distinct'
import { styles } from './checkboxCell.css'

const checkboxCell = ({ selectedIds, onChange }) => {
  return withStyles(styles)(class CheckboxCell extends GridCell {
    getId = () => { return this.props.dataItem[this.props.field] }
    handleChange = (e) => {
      onChange({ id: this.getId(), checked: e.target.checked })
    }
    render () {
      const id = this.getId()
      const checked = isNotNull(selectedIds.find(x => x === id))
      return (
        <td className='boolean-cell'>
          <input type='checkbox'
            className={this.props.classes.rowCheckbox}
            checked={checked}
            onChange={this.handleChange}
          />
        </td>
      )
    }
  })
}

const createCheckBoxHeaderCell = ({ selectedIds, data = [], onChange }) => {
  return withStyles(styles)(withDialogs(localized(class CheckboxHeaderCell extends GridHeaderCell {
    handleChange = (e) => {
      const { checked } = e.target
      let newIds
      if (checked) {
        newIds = selectedIds
          .concat(data.map(x => x.id))
          .distinct()
      } else {
        newIds = [...selectedIds]
        for(let i = 0; i < data.length; i++) {
          newIds = newIds.filter(x => x !== data[i].id)
        }
      }
      onChange(newIds)
    }
    handleDeselectAll = () => {
      this.props.showConfirm({ 
        confirmMessage: this.props.localize('common.gridDeselectAllConfirm'), 
        onConfirm: () => onChange([])
      })
    }
    render () {
      let checked = true
      for(let i = 0; i < data.length; i++) {
        if (isNull(selectedIds.find(x => x === data[i].id))) {
          checked = false
          break
        }
      }
      return (
        <React.Fragment>
          <div className={this.props.classes.totalCheckedItems}
            title={this.props.localize('common.gridDeselectAllTooltip')}
            onClick={this.handleDeselectAll}>
            <Badge
              badgeContent={selectedIds.length}
              color='primary'
              anchorOrigin={{ vertical: 'top', horizontal: 'right'}}
            />
          </div>
          <input type='checkbox'
            className={this.props.classes.titleCheckbox}
            checked={checked}
            title={this.props.localize(checked ? 'common.gridUncheckAll' : 'common.gridCheckAll')}
            onChange={this.handleChange}
          />
        </React.Fragment>
      )
    }
  })))
}

export {
  checkboxCell,
  createCheckBoxHeaderCell
}
